export async function blobToDataUri(blob: Blob): Promise<string> {
	return new Promise((resolve, reject) => {
		const reader = new FileReader()
		reader.onload = () => {
			resolve(reader.result as string)
		}
		reader.onerror = () => {
			reject(new Error('[t9brdt] Failed to read blob as data URI'))
		}
		reader.readAsDataURL(blob)
	})
}
